import { InvalidFileError } from '../../types';

type ShowFileErrorProps = {
  t: (key: string, options?: Record<string, string | number>) => string;
  file: File;
  error: InvalidFileError;
};

export const showFileError = ({ t, file, error }: ShowFileErrorProps): string => {
  if (error.name === 'file-type-not-allowed' || error.name === 'image-not-square') {
    return t(`common:file_uploader:error:${error.name}`, { fileName: file.name });
  } else if (error.name === 'file-too-large') {
    // assume the max size is in bytes, so we need to convert to kb
    return t(`common:file_uploader:error:${error.name}`, { fileName: file.name, maxSize: error.maxSize / 1000 });
  } else if (error.name === 'too-many-files') {
    return t(`common:file_uploader:error:${error.name}`, { fileName: file.name, maxFiles: error.maxFiles });
  } else if (error.name === 'image-dimensions-not-exact') {
    return t(`common:file_uploader:error:${error.name}`, {
      fileName: file.name,
      requiredWidth: error.requiredWidth,
      requiredHeight: error.requiredHeight,
    });
  } else if (error.name === 'image-dimensions-too-large') {
    return t(`common:file_uploader:error:${error.name}`, {
      fileName: file.name,
      maxWidth: error.maxWidth,
      maxHeight: error.maxHeight,
    });
  } else if (error.name === 'image-dimensions-too-small') {
    return t(`common:file_uploader:error:${error.name}`, {
      fileName: file.name,
      minWidth: error.minWidth,
      minHeight: error.minHeight,
    });
  }
  return t('common:file_uploader:error:generic');
};
